import { Table, Tag, Tooltip } from "antd";
import { CashbackReportData } from "../hooks/useCashbackReport";

interface CashbackReportTableProps {
  data: CashbackReportData[];
}

export const CashbackReportTable = ({ data }: CashbackReportTableProps) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("es-CO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const columns = [
    {
      title: "Producto",
      key: "product",
      render: (record: CashbackReportData) => (
        <div>
          <div style={{ fontWeight: "bold" }}>{record.product_name}</div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            ID: {record.product_id} | Código: {record.product_code}
          </div>
        </div>
      ),
      width: 200,
    },
    {
      title: "Marca",
      dataIndex: "brand_name",
      key: "brand_name",
      width: 120,
    },
    {
      title: "Categoría",
      dataIndex: "category_name",
      key: "category_name",
      width: 120,
    },

    {
      title: "Estado Producto",
      key: "product_status",
      render: (record: CashbackReportData) => {
        const color =
          record.product_status === "activo"
            ? "green"
            : record.product_status === "inactivo"
            ? "orange"
            : "red";
        return (
          <Tag color={color}>
            {record.product_status.charAt(0).toUpperCase() +
              record.product_status.slice(1)}
          </Tag>
        );
      },
      width: 120,
    },
    {
      title: "Porcentaje",
      key: "cashback_percentage",
      render: (record: CashbackReportData) => (
        <span>{record.cashback_percentage}%</span>
      ),
      width: 80,
    },
    {
      title: "Precio",
      key: "price",
      render: (record: CashbackReportData) => (
        <div>
          <div>{formatCurrency(record.price)}</div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            +IVA: {formatCurrency(record.price_with_tax)}
          </div>
        </div>
      ),
      width: 120,
    },
    {
      title: "Cantidad",
      dataIndex: "product_quantity",
      key: "product_quantity",
      width: 80,
    },
    {
      title: "Valor Total",
      key: "total_value",
      render: (record: CashbackReportData) => (
        <div>
          <div>{formatCurrency(record.total_product_value)}</div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            +IVA: {formatCurrency(record.total_product_value_with_tax)}
          </div>
        </div>
      ),
      width: 120,
    },
    {
      title: "Cashback",
      key: "cashback",
      render: (record: CashbackReportData) => (
        <div>
          <div style={{ fontWeight: "bold", color: "#3f8600" }}>
            {formatCurrency(record.cashback_amount)}
          </div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            Calculado: {formatCurrency(record.calculated_cashback_amount)}
          </div>
        </div>
      ),
      width: 120,
    },
    {
      title: "Orden",
      key: "order",
      render: (record: CashbackReportData) => (
        <div>
          <div>ID: {record.order_id}</div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            Total: {formatCurrency(record.total_price)}
          </div>
        </div>
      ),
      width: 120,
    },
    {
      title: "Estado Orden",
      key: "order_status",
      render: (record: CashbackReportData) => (
        <Tag color="blue">{record.order_status_name}</Tag>
      ),
      width: 100,
    },
    {
      title: "Fecha",
      key: "order_date",
      render: (record: CashbackReportData) => (
        <Tooltip title={record.order_date}>
          {formatDate(record.order_date)}
        </Tooltip>
      ),
      width: 120,
    },
    {
      title: "Usuario",
      key: "user",
      render: (record: CashbackReportData) => (
        <div>
          <div>
            {record.first_name} {record.last_name}
          </div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            ID: {record.user_id}
          </div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            {record.user_email}
          </div>
        </div>
      ),
      width: 150,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(record) => `${record.order_id}-${record.product_id}`}
      pagination={{
        pageSize: 20,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} de ${total} registros`,
      }}
      scroll={{ x: 1500 }}
      size="small"
    />
  );
};
